module.exports = __webpack_public_path__ + "static/img/RWA1864-G_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RWA1864-G_1.png
// module id = Gd1X
// module chunks = 0